import * as React from 'react';
import { connect } from 'react-redux';
import { OutputsDialog } from '../components';
import store from '../store/store';
import types from '../store/types';
import { IOutput, EModalType, IdHelper, ModalHelper, IToolsState, IValidationResponse, ComponentHelper, IMoveHandler, OutputsHelper } from '../helpers';
import { IDropdownOption } from 'office-ui-fabric-react';
class OutputsDialogContainer extends React.Component<any, any> {

    addOutput = (): void => {
        let id: string = IdHelper.newGuid();
        store.dispatch({ type: types.ADD_GLOBAL_OUTPUT, id: id });
        ModalHelper.scrollToBottom();      
    }
    
    updateOutput = (output: IOutput): void => {
        store.dispatch({ type: types.UPDATE_GLOBAL_OUTPUT, output: output });
    }
    removeOutput = (outputId: string): void => {
        store.dispatch({ type: types.DELETE_GLOBAL_OUTPUT, outputId: outputId });
    }

    dispatchErrorMessages = (errorMessages:string[]) =>{
        store.dispatch({
            type: types.SET_MODAL_ERROR_MESSAGES,
            errorMessages: errorMessages
        });

        if(!errorMessages.length) {

            store.dispatch({
                type: types.SET_MODAL_ERROR_MESSAGES,
                errorMessages: []
            });

            store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
        }
    }
    closeDialog = (save?: boolean) => {
        let { outputs, originalGlobalOutputs, toolState, state } = this.props;

        // Save the outputs
        if (save)
        {
            let errorMessages: string[] = [];
            
            if(outputs) {
                
                errorMessages = errorMessages.concat(OutputsHelper.getErrorMessagesForGlobalAndLoopOutputs(outputs, false));
                
                if(errorMessages && errorMessages.length > 0)
                {
                    this.dispatchErrorMessages(errorMessages);
                }
                else
                {
                    ComponentHelper.validateComponentProperties("Global output values",null,null,outputs,null).then(
                        (validationResponse: IValidationResponse) => {

						let errorMessages: string[] = validationResponse.errorMessages.map((e) => e.clientErrorMessage);
						let warningMessages: string[] = validationResponse.warningMessages.map((w) => w.clientErrorMessage);
						if(errorMessages.length || warningMessages.length) {
							store.dispatch({
								type: types.SET_MODAL_ERROR_MESSAGES,
								errorMessages: errorMessages
							});
							this.setModalWarningMessages(warningMessages);
							ModalHelper.scrollToErrorDisplay();
						}
                        else
                        {
                            //set the isSharedJourneyOutput on all outputs if the journey is a shared one
                            if(toolState.isSharedJourney && outputs) {
                                outputs.forEach(o => {
                                    o.DisplayOnSummary = false;
                                });
                            }
                            
                            store.dispatch({ type: types.UPDATE_GLOBAL_OUTPUTS, outputs: outputs });
                            store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
                        }
                 });
              }
          }
        }
        else {
            store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
            store.dispatch({ type: types.SET_GLOBAL_OUTPUTS_STATE, outputs: originalGlobalOutputs });
        }

    }
    
    setModalWarningMessages = (warningMessages: string[]) => {
		store.dispatch({
			type: types.SET_MODAL_WARNING_MESSAGES,
			warningMessages: warningMessages
		});
		ModalHelper.scrollToErrorDisplay();
	}
    updateOutputName = (name: string, id: string) => {

        let matches: IOutput[] = this.props.outputs.filter(o => o.Id === id);

        if (!matches.length)
            return;

        let output: IOutput = { ...matches[0] };
        output.Name = name;

        this.updateOutput(output);

    }

    updateOutputLogicalName = (logicalName: string, id: string) => {

        let matches: IOutput[] = this.props.outputs.filter(o => o.Id === id);

        if (!matches.length)
            return;

        let output: IOutput = { ...matches[0] };
        output.LogicalName = logicalName;
        // Logical name cannot contain spaces. replace with "_";
        output.LogicalName = output.LogicalName.replace(/ /ig, "_");
        // Logical name must only consist of lower case letters, or numbers - toLower()
        output.LogicalName = output.LogicalName.toLowerCase();

        this.updateOutput(output);
    }

    updateOutputType = (type: number, id: string) => {

        let matches: IOutput[] = this.props.outputs.filter(o => o.Id === id);

        if (!matches.length)
            return;

        let output: IOutput = { ...matches[0] };
        output.Type = +type;

        this.updateOutput(output);

    }

    updateCanBeSetByQueryString = (canBeSetByQueryString: boolean, id: string) => {

        let matches: IOutput[] = this.props.outputs.filter(o => o.Id === id);

        if (!matches.length)
            return;

        let output: IOutput = { ...matches[0] };
        output.CanBeSetByQueryString = canBeSetByQueryString;

        this.updateOutput(output);

    }

    moveHandler: IMoveHandler = {
        drag: (e, index: number) => {
            store.dispatch({ type: types.SET_MOVE_FROM_GLOBAL_OUTPUT, index: index });
        },
        drop: (e, toIndex: number) => {

            e.preventDefault();
            store.dispatch({ type: types.MOVE_GLOBAL_OUTPUT, toIndex: toIndex });

        },
        allowDrop: (e, i: number) => {
            e.preventDefault();

            if (i !== this.props.overIndex)
                store.dispatch({ type: types.SET_MOVE_OVER_GLOBAL_OUTPUT, index: i });
        }
    };

    public render() {

        let { outputs, overIndex, types, isSharedJourney } = this.props;
        let toolState: IToolsState = this.props.toolState;

        return <OutputsDialog outputs={outputs}
            addOutput={this.addOutput}
            updateOutputName={this.updateOutputName}
            updateOutputLogicalName={this.updateOutputLogicalName}
            updateOutputType={this.updateOutputType}
            updateCanBeSetByQueryString={this.updateCanBeSetByQueryString}
            removeOutput={this.removeOutput}
            closeDialog={this.closeDialog}
            moveHandler={this.moveHandler}
            overIndex={overIndex}
            types={types}
            isSharedJourney={toolState.isSharedJourney}
        />;
    }

}

const mapStateToProps = (store) => {

    let types: IDropdownOption[] = store.cacheState.outputTypes
        .map((output: IOutput) => {
            return { key: output.Type, text: output.Name };
        });

    return {
        toolState: store.toolsState,
        outputs: store.modalState.outputsDialogState.outputs,
        overIndex: store.modalState.outputsDialogState.overIndex,
        types: types,
        originalGlobalOutputs: store.outputsState.globalOutputs   
    };
};

export default connect<any, any, any>(mapStateToProps)(OutputsDialogContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/outputs-dialog.tsx